import script from "./MobileBusiness.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileBusiness.vue?vue&type=script&lang=ts&setup=true"

import "./MobileBusiness.vue?vue&type=style&index=0&id=768bf2d6&scoped=true&lang=less"

import exportComponent from "D:\\sunrun_luo\\JK-neibu\\JKai-zhuzhan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-768bf2d6"]])

export default __exports__